// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3hNjm","bigColWidth":"Table_bigColWidth__5BVtf","biggerColWidth":"Table_biggerColWidth__3dSjC","row":"Table_row__1WnEq","col":"Table_col__2kcFk"};